import { render } from "./ContactGroupAction.vue?vue&type=template&id=e81a49a8&scoped=true&ts=true"
import script from "./ContactGroupAction.vue?vue&type=script&lang=ts"
export * from "./ContactGroupAction.vue?vue&type=script&lang=ts"

import "./ContactGroupAction.vue?vue&type=style&index=0&id=e81a49a8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81a49a8"]])

export default __exports__